export default __webpack_public_path__ + "static/media/drop-arrow.17add12e.svg";